import React from 'react';
import PropTypes from 'prop-types';
import {
  ToggleSwitchWrapper,
  ToggleSwitchCheckbox,
  ToggleSwitchLabel,
  ToggleSwitchInner,
  ToggleSwitchSwitch,
} from '../ToggleSwitch.style';

const ToggleSwitch = ({
  id,
  name,
  checked,
  onChange,
  optionLabels,
  className,
  disabled,
  switchColor,
  offColor,
  toggleSwitchSwitchColor,
}) => {
  function handleKeyPress(e) {
    if (e.keyCode !== 32) return;
    e.preventDefault();
    onChange(!checked);
  }

  return (
    <ToggleSwitchWrapper className={className}>
      <ToggleSwitchCheckbox
        type="checkbox"
        name={name}
        className="toggle-switch-checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      {id ? (
        <ToggleSwitchLabel
          className="toggle-switch-label"
          htmlFor={id}
          tabIndex={disabled ? -1 : 1}
          onKeyDown={(e) => {
            handleKeyPress(e);
          }}
        >
          <ToggleSwitchInner
            className={
              disabled ? 'toggle-switch-inner toggle-switch-disabled' : 'toggle-switch-inner'
            }
            data-yes={optionLabels[0]}
            data-no={optionLabels[1]}
            tabIndex={-1}
            switchColor={switchColor}
            offColor={offColor}
          />
          <ToggleSwitchSwitch
            className={
              disabled ? 'toggle-switch-switch toggle-switch-disabled' : 'toggle-switch-switch'
            }
            toggleSwitchSwitchColor={toggleSwitchSwitchColor}
            tabIndex={-1}
          />
        </ToggleSwitchLabel>
      ) : null}
    </ToggleSwitchWrapper>
  );
};

// Set optionLabels for rendering.
ToggleSwitch.defaultProps = {
  optionLabels: ['On', 'Off'],
  disabled: false,
  name: 'filter-switch',
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  optionLabels: PropTypes.array,
  disabled: PropTypes.bool,
  switchColor: PropTypes.bool,
  offColor: PropTypes.string,
};

export default ToggleSwitch;
export { ToggleSwitch as ToggleSwitchVanilla };
